"use client";

import { useEffect, useState } from "react";
import VegaEmbed from "@/components/VegaEmbed";


// P1 ใน CustomChart.tsx (line 20) คือปัญหาเรื่องข้อมูลค้างตอนสลับ division
// ตัว CustomChart จะโหลดข้อมูลใหม่ใน useEffect เฉพาะตอน filename, datasetId หรือ onEvent เปลี่ยน แต่ path จริงของไฟล์ parquet ยังขึ้นกับ prefix ด้วย ซึ่ง prefix คือส่วนที่เปลี่ยนตาม division. ปัญหาคือใน grid นี้ใช้ key={item.filename} อย่างเดียว ถ้า division A กับ division B มี custom chart ชื่อไฟล์เดียวกัน React จะ reuse component เดิม ไม่ remount ใหม่ และเพราะ prefix ไม่ได้อยู่ใน dependency ของ useEffect จึงไม่ยิง fetch ใหม่ ผลคือกราฟยังแสดงข้อมูลของ division เก่า ทั้งที่ผู้ใช้เปลี่ยน division ไปแล้ว

export default function CustomChart(props: any) {
  const [chartData, setChartData] = useState<any[]>([]);

  useEffect(() => {
    if (!props.filename || !props.datasetId || !props.onEvent) return;
    setChartData([]);
    props.onEvent({
      message: "GetCustomChartData",
      params: {
        filename: props.filename,
        datasetId: props.datasetId,
        setData: setChartData,
        prefix: props.prefix || "",
      }
    });
  }, [props.filename, props.datasetId, props.prefix, props.onEvent]);

  if (!props.vegaSpec) return <div>No spec provided</div>;

  const spec = {
    ...props.vegaSpec,
    data: { values: chartData },
    width: props.width || "container",
    height: props.height || 300
  };

  return (
    <div style={{ width: "100%" }}>
      <VegaEmbed data={spec} />
    </div>
  );
}
